import { render, staticRenderFns } from "./g-header.vue?vue&type=template&id=166848c4&scoped=true"
import script from "./g-header.vue?vue&type=script&lang=js"
export * from "./g-header.vue?vue&type=script&lang=js"
import style0 from "./g-header.vue?vue&type=style&index=0&id=166848c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166848c4",
  null
  
)

export default component.exports